module.exports = __webpack_public_path__ + "static/media/ti-desktop.6b8e1ca5.png";